import { render, staticRenderFns } from "./AddToCollectionModal.vue?vue&type=template&id=f75c7c50"
import script from "./AddToCollectionModal.vue?vue&type=script&lang=js"
export * from "./AddToCollectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports